import * as Yup from "yup";

export const AmendmentValidation = Yup.object({
    name: Yup.string().required("Name is required!"),
    date: Yup.string().required("Date is required!"),
})
